import { useMutation } from '@tanstack/react-query'

import { getPcJwtSso } from '@src/api'
import { useAxios } from '@src/hooks/use-axios'
import { BASE_UPSIDER_IAM_URL } from '@src/utils'

export const useSetMoneytreePcJwtOnLogin = (jwt: string) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })
  //Due to the contract with moneytree, it is necessary to communicate from
  // the PRESIDENT CARD client in the UPSIDER api domain.
  axiosInstance.defaults.baseURL = BASE_UPSIDER_IAM_URL()
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${jwt}`

  return useMutation({
    mutationFn: () => getPcJwtSso(axiosInstance),
  })
}
